// src/App.js — React Router setup
import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';

import Login from './components/Login';
import Register from './components/Register';
import Navbar from './components/Navbar';
import Aiagent from './components/Aiagent';
import Termsofservice from './components/Termsofservice';
import Privacypolicy from './components/Privacypolicy';
import Dynamicqr  from './products/Dynamicqr';
import Flapaccessories from './products/Flapaccessories';
import Flapstand  from './products/Flapstand';
import Flapwallet from './products/Flapwallet';
import Physicalcard  from './products/Physicalcard';
import Keyrings  from './products/Keyrings';


import Order           from './pages/Order';
import NfcMonitor    from './components/Nfcmonitor';
import WriteNFC      from './pages/Writenfc';
import Device        from './pages/Device';

import TagPublicView from './pages/TagPublicView';


//import Aiagent from './components/Aiagent';
import Home from './components/Home';
import Profile from './pages/Profile';
import BusinessSetup    from './pages/Businesssetup';
import BusinessDashboard from './pages/Businessdashboard';

import Analytics from './pages/Analytics';
import UserInfo from './pages/UserInfo';
import Abouts from './pages/Abouts'
import Contactowner from './pages/Contactowner'
import AdminDashboard from './components/AdminDashboard';
import UserDashboard from './pages/UserDashboard';
import ProductManager from './components/ProductManager';
import QRScanner from './components/QRScanner';
import Linkaccessories from './pages/Linkaccessories';

import Contact from './pages/Contact';
import Messages from './pages/Messages'
import SuperAdmin from './pages/Superadmin';

import AuthCallback    from './components/AuthCallback';
import ForgotPassword  from './components/ForgotPassword';
import ResetPassword   from './components/ResetPassword';

import BusinessInfo    from './pages/Businessinfo';
import Explore         from './pages/Explore';
import Passport        from './pages/Passport';
import Storefront      from './pages/Storefront';
import SocialFeed      from './pages/Socialfeed';
import AddPlace        from './pages/Addplace';
import Booking         from './pages/Booking';

// ── Auth guard ────────────────────────────────────────────────────────────────
function PrivateRoute({ children }) {
  const token = localStorage.getItem('token');
  return token ? children : <Navigate to="/login" replace />;
}

export default function App() {
  return (
    
    <BrowserRouter>
      
      <Routes>
       
        {/* ── Public pages ──────────────────────────────────────────── */}
        <Route path="/"              element={<Home />} />
        
        <Route path="/login"         element={<Login />} />
        <Route path="/register"      element={<Register />} />
        <Route path="/privacy-policy"       element={<Privacypolicy />} />
        <Route path="/terms-of-service"         element={<Termsofservice />} />
        <Route path="/about-flap"         element={<Abouts />} />
        <Route path="/link-flap"         element={<Linkaccessories />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password"  element={<ResetPassword />} />
        <Route path="/auth/callback"   element={<AuthCallback />} />
        {/* ── Protected pages ───────────────────────────────────────── */}
        
        <Route path="/flap-wallet" element={<Flapwallet />} />
        <Route path="/dynamic-qr" element={<Dynamicqr />} />
        <Route path="/physical-card" element={<Physicalcard />} />
        <Route path="/flap-stand" element={<Flapstand />} />
        <Route path="/flap-accessories" element={<Flapaccessories />} />
        <Route path="/keyrings" element={<Keyrings />} />

        <Route path="/admin"         element={<PrivateRoute><SuperAdmin /></PrivateRoute>} />
        <Route path="/ai-agent"      element={<PrivateRoute><Aiagent /></PrivateRoute>} />
        <Route path="/nfc-monitor"    element={<PrivateRoute><NfcMonitor /></PrivateRoute>} />
        <Route path="/write-nfc"      element={<PrivateRoute><WriteNFC /></PrivateRoute>} />     
        <Route path="/device"         element={<PrivateRoute><Device /></PrivateRoute>} />

        <Route path="/profile" element={<Profile />} />
        <Route path="/business"      element={<BusinessSetup />} />
        <Route path="/business/:id"  element={<BusinessDashboard />} />
        <Route path="/admin"     element={<SuperAdmin />} />
        <Route path="/analytics" element={<Analytics />} />
        <Route path="/contacts" element={<Contact />} />
        <Route path="/messages" element={<Messages />} />
        
        
        <Route path="/admin-dashboard" element={<AdminDashboard />} />
        <Route path="/dashboard" element={<UserDashboard />} />
        <Route path="/products" element={<ProductManager />} />
        <Route path="/qr-scan" element={<QRScanner />} /> {/* For Stand QR auth */}
        {/* Add route for /stand/:flapid - public profile view */}

        {/* ── Semi-public NFC/QR resolved pages ─────────────────────── */}
        {/* ── Platform pages ───────────────────────────────────────── */}
        <Route path="/explore"      element={<Explore />} />
        <Route path="/passport"     element={<PrivateRoute><Passport /></PrivateRoute>} />
        <Route path="/b/:slug"      element={<BusinessInfo />} />
        <Route path="/cart/:bizId"  element={<PrivateRoute><Storefront /></PrivateRoute>} />
        <Route path="/cart"         element={<PrivateRoute><Storefront /></PrivateRoute>} />
        <Route path="/feed"         element={<PrivateRoute><SocialFeed /></PrivateRoute>} />
        <Route path="/places/new"   element={<PrivateRoute><AddPlace /></PrivateRoute>} />
        <Route path="/booking/:bizId" element={<PrivateRoute><Booking /></PrivateRoute>} />
 
        
        
       
        
        
        
        

        {/* ── Catch-all — flapid short URL (MUST be last) ───────────── */}
        <Route path="/v/:flapid" element={<TagPublicView />} />
        
        <Route path="/:flapid"       element={<UserInfo />} />
        <Route path="/contactowner/:flapid" element={<Contactowner />} />

        
        <Route path="/orders"       element={<Order />} />

      </Routes>
   </BrowserRouter>
  );
}